// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 7 5"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.03244 0.861278C3.29279 0.600928 3.7149 0.600928 3.97524 0.861278L6.36577 3.2518C6.78575 3.67178 6.4883 4.38987 5.89436 4.38987L1.11332 4.38987C0.519379 4.38987 0.221935 3.67178 0.641911 3.2518L3.03244 0.861278Z"
    />
  </svg>
);
const IconArrowUp = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconArrowUp;
